import { PropertyReportButtonService } from 'common/service/property-report-button/service';
import { PropertyCardSectionsFooterComponentFactory } from 'desktop/module/property/card/sections/footer/component.factory';
import { PropertyPageSocialShareViewService } from 'desktop/service/property-page-social-share/service';

export const PropertyCardSectionsFooterComponent = PropertyCardSectionsFooterComponentFactory({
  propertyReportService: PropertyReportButtonService(),
  socialShareViewStore: PropertyPageSocialShareViewService(),
});
